export default [
    {
        path: "/reverse-auction/auction-config",
        name: "auction-config",
        meta: {title: "Auction Configurations", authRequired: true},
        component: () => import("../views/reverse-auction/auction-config.vue"),
    },

    {
        path: "/reverse-auction/upcoming-auctions",
        name: "upcoming-auctions",
        meta: {title: "Upcoming Auctions", authRequired: true},
        component: () => import("../views/reverse-auction/upcoming-auctions.vue"),
    },

    {
        path: "/reverse-auction/scheduled-auctions",
        name: "scheduled-auctions",
        meta: {title: "Scheduled Auctions", authRequired: true},
        component: () => import("../views/reverse-auction/scheduled-auctions.vue"),
    },

    {
        path: "/reverse-auction/live-auctions",
        name: "live-auctions",
        meta: {title: "Live Auctions", authRequired: true},
        component: () => import("../views/reverse-auction/live-auctions.vue"),
    },

    {
        path: "/reverse-auction/auction-ranking",
        name: "auction-ranking",
        meta: {title: "Auction Ranking", authRequired: true},
        component: () => import("../views/reverse-auction/auction-ranking.vue"),
    },
]